import { useEffect } from 'react'

import { useBankPortalContext } from 'bank-portal-context'
import { SubMenuItem } from 'commons/types/DTO/commons'

export const useSecondaryMenu = (items: SubMenuItem[]) => {
  const context = useBankPortalContext()

  useEffect(() => {
    context.setCustomSidebarItems(items)
    return () => context.setCustomSidebarItems([])
  }, [JSON.stringify(items)])
}
